<template>
  <footer class="footer section">
    <div class="container-wrapper">

      <div class="colFlex">
        <div style="width:100%;" class="colFlex-widget">

          <div class="widget">
            <h4 class="text-capitalize  mb-4">{{ $t("l.header.productLink") }}</h4>
            <ul class="list-unstyled footer-menu lh-42 ">
              <li><a @click="jumpAssistant(0)">{{ $t("l.header.Electricpower") }}</a></li>
              <li><a @click="jumpAssistant(1)">{{ $t("l.header.smartExecutionLink") }}</a></li>
              <li><a @click="jumpAssistant(2)">{{ $t("l.header.smartAnalyticsLink") }}</a></li>
              <li><a @click="jumpAssistant(3)">{{ $t("l.header.industrialChainLink") }}</a></li>
              <li><a @click="jumpAssistant(4)">{{ $t("l.header.edu") }}</a></li>
              <li><a @click="jumpAssistant(5)">{{ $t("l.header.transactionMonitoring") }}</a></li>

            </ul>
          </div>
          <div class="widget">
            <h4 class="text-capitalize mb-4">{{ $t("l.header.aboutLink") }}</h4>
            <ul class="list-unstyled footer-menu lh-42">
              <li><a @click="jumpAbout()">{{ $t("l.header.teamLink") }}</a></li>
              <li><a @click="jumpAbout()">{{ $t("l.header.awardsLink") }}</a></li>
              <li><a @click="jumpBusiness()">{{ $t("l.header.businessCase") }}</a></li>
            </ul>
          </div>
          <div class="widget">
            <h4 class="text-capitalize mb-4">{{ $t("l.header.contactLink") }}</h4>
            <ul class="list-unstyled footer-menu lh-42">
              <li><a @click="jumpContact()">{{ $t("l.header.contactDownLink") }}</a></li>
            </ul>
          </div>

          <div class="widget">
            <div class="logo mb-4">
              <img src="../../../src/assets/images/newImgs/logo.png" class="logoImg" />
              <!--                  <h3>{{ $t("l.header.title") }}</h3>-->
              <!-- <div class="col-lg-6 ml-auto col-sm-6">
                  <div class="widget">
                      <div class="logo mb-4">
                          <h3>{{ $t("l.header.title") }}</h3>
                      </div>
                      <h6>
                          <a href="tel:+23-345-67890"
                              >zhangwy@datafareast.cn</a
                          >
                      </h6>
                      <a href="mailto:support@gmail.com"
                          ><span class="text-color h4"
                              >0571-8678 2275</span
                          ></a
                      >
                  </div>
              </div> -->
            </div>
            <span class="text-color text-color-top h4">{{ $t("l.header.phone") }}:0571-8678 2275</span>
            <h6  class="text-color h4">
              {{ $t("l.header.email") }}:zhuyongqi@datafareast.cn
              <!--                  <a href="tel:+23-345-67890"></a>-->
            </h6>
          </div>
        </div>
      </div>

      <div class="footer-btm pt-3">
        <div class="row">
          <div class="col-lg-12">
            <div class="copyright">
              &copy; 2021-现在 迈柘DATAFAREAST.CN 版权所有
              <div class="policeImg">
                <img src="../../assets/images/police.png" />
              </div>
              <a href="https://beian.miit.gov.cn" target="_blank">浙公网安备 33010202001903号 浙ICP备2021026751号</a>
            </div>
          </div>
          <div class="col-lg-6 text-left text-lg-right">
            <ul class="list-inline footer-socials"></ul>
          </div>
        </div>
      </div>
    </div>
    <goBack />
  </footer>
</template>

<script>

import goBack from "./goBack";
import Header from "../Header";
import BigImg from "../BigImg";
export default {
  name: "Footer",
  components: {
    goBack
  },
  data() {
    return {
      // msg: "Welcome to Your Vue.js App",
    };
  },
  methods: {
    // 首页
        jumpHome() {
            this.$router.push("/");
        },
        // 关于我们
        jumpAbout() {
            this.$router.push("/about");
        },
        // 公司荣誉
        jumpHonor() {
            this.$router.push("/aboutHonor");
        },
        // 公司历程
        jumpHistory() {
            this.$router.push("/aboutHistory");
        },
        // 团队商业案例
        jumpBusiness() {
            this.$router.push("/businessCase");
        },
        // 联系我们
        jumpContact() {
            this.$router.push("/contact");
        },
         // 智能交易
        jumpAssistant(type) {
            this.$router.push(`/smartExecution?type=${type}`);
        },
        // 智能投研
        jumpInvestment() {
            this.$router.push("/smartAnalytics");
        },
        // 产业链
        jumpIndustrialChain() {
            this.$router.push("/industrialChain");
        },
         // 教育科研
        jumpEduAndResearch() {
            this.$router.push("/eduAndResearch");
        },
        // 交易监查
        jumpTransaction() {
            this.$router.push("/transactionSupervision");
        }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container-wrapper {
  text-align: left;
  width:1000px;
  margin:0 auto;
  .rowContainer{
    justify-content: center;
    .colPadding{
      padding:0;
    }


  }
  .widget{
    padding-left:0;
    margin-bottom:0;
    padding-bottom:0;
  }
  .logoImg{
    width: 359px;
    //margin-top:-1.5rem;
  }
  .colFlex{
    display: flex;
    justify-content: space-between;
    .colFlex-widget{
      display: flex;
      justify-content: space-between;
    }
  }
  .text-color{
    padding-left: 50px;
    font-size: 16px;
    color:rgba(89, 89, 89, 1);
    font-weight: unset;
  }
  .text-color-top{
    margin-top:-1.5rem;
    display: block;
  }
}
.copyright {
  line-height: 20px;
  font-size: 14px;
  text-align: center;
  a{
    font-weight: initial;
  }
}
.policeImg {
  display: inline-block;
  line-height: 25px;
  margin-left: 10px;
}
.footer{
  background: rgba(240, 240, 240, 1);
}
.section{
  padding-top: 24px;
}
.footer-menu li:hover{
  color: #005fb1;
}
.text-capitalize{
  font-size: 24px;
  color:rgba(89, 89, 89, 1);
}
.list-unstyled{
  a{
    color: rgba(89, 89, 89, 1);
  }
}
.lh-42{
  line-height: 20px;
  li{
    margin-bottom:22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue